<template>
  <div class="customers">
    <EntityList
      v-bind:endpoint="'api/customers'"
      v-bind:filters="''"
      v-bind:entity="customerEntity"
      v-bind:editAllowedFields="['name', 'code', 'logo']"
      v-bind:notDisplayedFields="['id', 'timestamp']"
      v-bind:notShowEditAction="true"
      v-bind:notShowDeleteAction="false"
      v-bind:addLinkToDetails="true"
      v-bind:detailsRouterName="'customerdetails'"
      v-bind:defaultValues="{}"
      v-bind:title="'Customers'"
      v-bind:enableSearch="true"
      v-bind:searchFields="[{ text: 'Customer Name', value: 'name' }, { text: 'Customer Code', value: 'code', exact: true }]"/>
  </div>
</template>

<script>
import EntityList from './EntityList/EntityList.vue';
import CustomerEntity from '../store/entity/Customer';

export default {
  name: 'customers',
  components: { EntityList },
  data() {
    return {
      customerEntity: CustomerEntity,
    };
  },
  created() {
    this.$store.commit('resetBackRoute');
  },
};

</script>
